import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../services/filtering/filter-form-render-service/';
import { messages } from './messages';

export const ItemSku = {
  id: 'itemSku',
  displayName: <FormattedMessage {...messages.itemSku} />,
  type: OptionFormTypes.TYPE_STRING,
  filterValue: 'ItemSku',

  render: (criteriaInformations) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_STRING, criteriaInformations);
  },
};
